/* assets/rod-sepet-stok.js : AYNI ÜRÜNÜN TEKİLİ VE PAKETİ SEPETTE BİRLİKTEYKEN STOK TOPLAMI DENETİMİ.
   snippets/rod-head.liquid her sayfada, öteki modüllerden ÖNCE yükler.

   NEDEN (sahip, 19.10.2026; #1547): Shopify tekil ürünün (ROD01802) ve paketinin (ROD01802-PKT-10) stoğunu
   ayrı ayrı denetliyor. Stokta 12 adet varken tekilden 12 ve paketten 1 aynı sepette satılabildi (22 adet);
   paket gönderilemedi. Ödeme doğrulaması (Shopify Functions) bu mağazanın planında (Grow) özel uygulamaya
   kapalı; sahibin önerisiyle denetim sepete eklemede yapılır.

   NASIL
   - Sepete yazan istekler TEK noktada yakalanır: window.fetch sarılır (POST /cart/add, /cart/change,
     /cart/update; .js / .json sonekli ya da sonsuz). Ürün sayfası, ürün kartı, hızlı ekleme, sepet çekmecesi ve
     sepet sayfası bu isteklerden geçtiği için bileşenlere tek tek dokunulmaz.
   - Aile SKU'dan anlaşılır: "<kök>-PKT-<N>" paketi kökün ailesidir (Rod Depo kuralı). Sepette bir ailenin
     yalnız TEK varyantı varsa denetim yapılmaz (Shopify o varyantın stoğunu kendisi denetler) ve hiçbir ek istek
     atılmaz. Ailenin iki varyantı birlikteyse Rod Depo'ya sorulur (/apps/rod-depo/sepet-stok, vekil imzalı):
     kesin stok ve paket katsayısı oradadır (app/lib/sepet-stok.ts).
   - Ekleme: istek önce Shopify'a gider (eklenen varyantın SKU'su yanıttan öğrenilir), aşım varsa EKLENEN ADET
     geri alınır ve çağırana Shopify biçiminde 422 döner; bileşen kendi hata yerinde Türkçe cümleyi gösterir.
     Adet değiştirme: istek gönderilmeden önce sepetin yeni hâli denetlenir, aşımda istek hiç gitmez.
   - ARIZADA SATIŞ DURMAZ: Rod Depo yanıt vermezse, yanıt bozuksa ya da bu betikte bir hata olursa istek olduğu
     gibi geçer. Son güvence depodaki kuraldır: stoğu ayrılamayan sipariş karar verilmeden kargoya verilmez.
*/
const ADRES = '/apps/rod-depo/sepet-stok';
const SURE_MS = 4000;
const PAKET = /-PKT-?\d+$/i;
const ASIL = window.fetch.bind(window);

const kok = (sku) => String(sku || '').trim().toUpperCase().replace(PAKET, '');
const sayi = (deger, varsayilan) => {
  const n = Number(deger ?? varsayilan);
  return Number.isFinite(n) ? n : NaN;
};

/** İsteğin sepet türü: 'ekle' | 'degistir' | 'guncelle' | null. */
function sepetTuru(girdi, ayar) {
  if (girdi instanceof Request) return null;
  const yontem = String(ayar?.method || 'GET').toUpperCase();
  if (yontem !== 'POST') return null;
  let yol = '';
  try {
    yol = new URL(typeof girdi === 'string' ? girdi : String(girdi), location.href).pathname.replace(/\.(js|json)$/, '');
  } catch {
    return null;
  }
  if (/\/cart\/add$/.test(yol)) return 'ekle';
  if (/\/cart\/change$/.test(yol)) return 'degistir';
  if (/\/cart\/update$/.test(yol)) return 'guncelle';
  return null;
}

/** Gövde: { json } ya da { form } (FormData / URLSearchParams); okunamazsa null. */
function govdeOku(govde) {
  if (!govde) return null;
  if (govde instanceof FormData || govde instanceof URLSearchParams) return { form: govde };
  if (typeof govde === 'string') {
    const metin = govde.trim();
    if (metin.startsWith('{')) {
      try {
        return { json: JSON.parse(metin) };
      } catch {
        return null;
      }
    }
    return { form: new URLSearchParams(metin) };
  }
  return null;
}

/** Eklenen satırlar: [{ id, quantity }]. */
function eklenenler(g) {
  let liste = [];
  if (g.json) {
    liste = Array.isArray(g.json.items) ? g.json.items : g.json.id != null ? [g.json] : [];
  } else {
    if (g.form.get('id')) liste.push({ id: g.form.get('id'), quantity: g.form.get('quantity') });
    for (let i = 0; i < 100; i++) {
      const id = g.form.get(`items[${i}][id]`);
      if (!id) break;
      liste.push({ id, quantity: g.form.get(`items[${i}][quantity]`) });
    }
  }
  return liste
    .map((s) => ({ id: sayi(s.id), quantity: sayi(s.quantity, 1) }))
    .filter((s) => s.id > 0 && s.quantity > 0);
}

async function sepetiOku() {
  const yanit = await ASIL(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  if (!yanit.ok) throw new Error('sepet okunamadı');
  return yanit.json();
}

/** Varyant → { kok, adet } (aynı varyantın satırları toplanır). */
function varyantAdetleri(kalemler) {
  const harita = new Map();
  for (const k of kalemler) {
    const onceki = harita.get(k.variant_id);
    harita.set(k.variant_id, { kok: kok(k.sku), adet: (onceki?.adet || 0) + k.quantity });
  }
  return harita;
}

/** Birden çok varyantla temsil edilen aileler (kök SKU kümesi). */
function karisikAileler(adetler) {
  const say = new Map();
  for (const { kok: k, adet } of adetler.values()) if (k && adet > 0) say.set(k, (say.get(k) || 0) + 1);
  return new Set([...say].filter(([, n]) => n > 1).map(([k]) => k));
}

/** Rod Depo'ya sorar; yanıt yoksa ya da bozuksa null (eklemeye engel olmaz). */
async function rodDepoyaSor(adetler, aileler) {
  const satirlar = [];
  for (const [varyant, { kok: k, adet }] of adetler) if (aileler.has(k) && adet > 0) satirlar.push({ varyant: String(varyant), adet });
  const kesici = new AbortController();
  const sayac = setTimeout(() => kesici.abort(), SURE_MS);
  try {
    const yanit = await ASIL(ADRES, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ satirlar }),
      signal: kesici.signal,
    });
    const govde = await yanit.json().catch(() => null);
    return govde && govde.ok === true && Array.isArray(govde.aileler) ? govde : null;
  } catch {
    return null;
  } finally {
    clearTimeout(sayac);
  }
}

/** Aşan ailelerden, verilen varyantlardan birini içeren ilki. */
function asanAile(denetim, varyantlar) {
  return denetim.aileler.find((a) => a.talep > a.kullanilabilir && a.varyantlar.some((v) => varyantlar.has(String(v)))) || null;
}

function cumle(aile, onceTalep) {
  const kalan = Math.max(0, aile.kullanilabilir - onceTalep);
  if (kalan === 0) return `Bu ürünün stoktaki ${aile.kullanilabilir} adedinin tamamı paketlerle birlikte sepetinizde.`;
  return `Stokta bu üründen ${aile.kullanilabilir} adet var; paketlerle birlikte sepetinize en çok ${kalan} adet daha ekleyebilirsiniz.`;
}

/** Shopify'ın sepet hatası biçimi: ürün formu `message`, sepet satırı `description`/`errors` okur. */
function hataYaniti(metin) {
  return new Response(JSON.stringify({ status: 422, message: metin, description: metin, errors: metin }), {
    status: 422,
    headers: { 'Content-Type': 'application/json' },
  });
}

async function ekle(girdi, ayar) {
  const istenen = eklenenler(govdeOku(ayar?.body) || { form: new URLSearchParams() });
  const yanit = await ASIL(girdi, ayar);
  if (!yanit.ok || !istenen.length) return yanit;
  try {
    const sepet = await sepetiOku();
    const adetler = varyantAdetleri(sepet.items || []);
    const aileler = karisikAileler(adetler);
    const ilgili = new Set(istenen.filter((s) => aileler.has(adetler.get(s.id)?.kok)).map((s) => String(s.id)));
    if (!ilgili.size) return yanit;
    const denetim = await rodDepoyaSor(adetler, aileler);
    const aile = denetim && asanAile(denetim, ilgili);
    if (!aile) return yanit;
    // Eklenen adet geri alınır: eklenen varyantın satırı (son eklenen satır anahtarıyla) eski adedine iner.
    let geriAlinan = 0;
    for (const s of istenen) {
      if (!aile.varyantlar.includes(String(s.id))) continue;
      const satir = (sepet.items || []).find((k) => k.variant_id === s.id);
      if (!satir) continue;
      const hedef = Math.max(0, satir.quantity - s.quantity);
      const degisim = await ASIL(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: satir.key, quantity: hedef }),
      });
      if (!degisim.ok) return yanit;
      geriAlinan += (satir.quantity - hedef) * (aile.carpanlar?.[String(s.id)] || 1);
    }
    return hataYaniti(cumle(aile, aile.talep - geriAlinan));
  } catch {
    return yanit;
  }
}

async function degistir(tur, girdi, ayar) {
  const g = govdeOku(ayar?.body);
  if (!g) return ASIL(girdi, ayar);
  try {
    const sepet = await sepetiOku();
    const kalemler = sepet.items || [];
    const yeni = kalemler.map((k) => k.quantity);
    const ata = (anahtar, adet) => {
      if (!Number.isFinite(adet) || adet < 0) return;
      const metin = String(anahtar);
      const sira = /^\d+$/.test(metin) ? kalemler.findIndex((k) => String(k.variant_id) === metin) : kalemler.findIndex((k) => k.key === metin);
      if (sira >= 0) yeni[sira] = adet;
    };
    const al = (ad) => (g.json ? g.json[ad] : g.form.get(ad));
    if (tur === 'degistir') {
      const adet = sayi(al('quantity'));
      const satir = sayi(al('line'));
      if (satir > 0 && satir <= kalemler.length) yeni[satir - 1] = adet;
      else if (al('id') != null) ata(al('id'), adet);
    } else {
      const updates = g.json ? g.json.updates : null;
      if (Array.isArray(updates)) updates.forEach((adet, i) => { if (i < yeni.length) yeni[i] = sayi(adet); });
      else if (updates && typeof updates === 'object') for (const [anahtar, adet] of Object.entries(updates)) ata(anahtar, sayi(adet));
      else if (g.form) for (const [ad, deger] of g.form) { const m = /^updates\[(.+)\]$/.exec(ad); if (m) ata(m[1], sayi(deger)); }
    }
    const artan = new Set(kalemler.filter((k, i) => yeni[i] > k.quantity).map((k) => String(k.variant_id)));
    if (!artan.size) return ASIL(girdi, ayar);
    const adetler = varyantAdetleri(kalemler.map((k, i) => ({ ...k, quantity: Math.max(0, yeni[i] || 0) })));
    const aileler = karisikAileler(adetler);
    if (![...artan].some((v) => aileler.has(adetler.get(Number(v))?.kok))) return ASIL(girdi, ayar);
    const denetim = await rodDepoyaSor(adetler, aileler);
    const aile = denetim && asanAile(denetim, artan);
    if (!aile) return ASIL(girdi, ayar);
    const onceTalep = aile.talep - kalemler.reduce((t, k, i) => {
      if (!aile.varyantlar.includes(String(k.variant_id)) || yeni[i] <= k.quantity) return t;
      return t + (yeni[i] - k.quantity) * (aile.carpanlar?.[String(k.variant_id)] || 1);
    }, 0);
    return hataYaniti(cumle(aile, onceTalep));
  } catch {
    return ASIL(girdi, ayar);
  }
}

if (!window.__rodSepetStok) {
  window.__rodSepetStok = true;
  window.fetch = function rodSepetStokFetch(girdi, ayar) {
    let tur = null;
    try {
      tur = sepetTuru(girdi, ayar);
    } catch {
      tur = null;
    }
    if (tur === 'ekle') return ekle(girdi, ayar);
    if (tur === 'degistir' || tur === 'guncelle') return degistir(tur, girdi, ayar);
    return ASIL(girdi, ayar);
  };
}
